import { ConfirmModal } from 'components/modal/ConfirmModal';
import { CustomTable } from 'components/table/style';
import { iconSort } from 'components/table/utlil';
import { Row, Table, TextInput, closeModal, updateQueryStateTable } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

import { TABLE_KEY } from 'constants/table';

import { getLearnerColumns } from '../core/columns';
import { useLearnerController } from '../core/controller/learner';

export const LearnerPage = () => {
  const {
    learners,
    total,
    queryState,
    onClickAction,
    onSubmitDeleteLearner,
    onClickRow,
    searchValue,
    onChangeSearchValue,
  } = useLearnerController();

  const columns = getLearnerColumns(onClickAction);

  if (!queryState) {
    return null;
  }

  return (
    <Row direction="column" className="full-width">
      <TextInput
        containerStyle={{
          marginBottom: 16,
        }}
        value={searchValue.value}
        placeholder="Search by name, phone"
        onChange={onChangeSearchValue}
        inputStyle={{
          backgroundColor: 'transparent',
          width: '40%',
        }}
        prefix={<SearchIcon />}
      />
      <CustomTable>
        <Table
          columns={columns}
          dataSource={learners}
          total={total.value}
          tableKey={TABLE_KEY.LEARNERS}
          queryState={{
            ...queryState,
            orderBy:
              queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                ? 'name'
                : queryState.orderBy,
            orderDirection:
              queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                ? 'ASC'
                : queryState.orderDirection,
          }}
          updateQueryState={updateQueryStateTable}
          onClickRow={onClickRow}
          headerConfigs={{
            iconSort,
          }}
        />
      </CustomTable>
      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_LEARNER}
        content={'All the stored data of this client will be deleted. This action can not undo.'}
        header={`Delete client`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_LEARNER)}
        onSubmit={onSubmitDeleteLearner}
      />
    </Row>
  );
};
